export class RegisterIkModel {
    IkNummer: string;
    QuestionToken: string;
    QuestionAnswer: string;
    Email: string;

    constructor(ikNummer?: string, questionToken?: string, questionAnswer?: string, email?: string) {
        if (ikNummer) {
          this.IkNummer = ikNummer;
        }
        if (questionToken) {
          this.QuestionToken = questionToken;
        }
        if (questionAnswer) {
          this.QuestionAnswer = questionAnswer;
        }
        if (email) {
          this.Email = email;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/account/register/entities/registerIkModel.ts